import { Backdrop, CircularProgress } from "@mui/material";

export const DashboardLoader = () => {
  return (
    <div className="total-system-sales">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};
